<template>
  <div class="mask" v-show="value">
    <div class="content">
      <div class="hd">
        <span>请输入验证码</span>
        <img @click="handleClose" src="../../projects/hsbh5/assets/setting/close.png"/>
      </div>
      <div class="bd">
        <input class="input" v-model="limitCode" placeholder="输入验证码"/>
        <img v-show="codeImgSrc" class="code-img" :src="codeImgSrc" @click="onClickImg">
      </div>
      <div class="ft">
        <h-button class="button" type="primary" size="large" @click="confirm">提交</h-button>
      </div>
    </div>
  </div>
</template>

<script>
import hButton from '@/components/button';
export default {
  components: {
    hButton
  },
  props: {
    value: Boolean,
    codeImgSrc: String
  },
  data () {
    return {
      limitCode: ''
    };
  },
  watch: {
    limitCode (val) {
      this.$emit('on-code-changed', val);
    }
  },
  methods: {
    confirm () {
      this.$emit('on-confirm', this.limitCode);
      this.limitCode = '';
    },
    handleClose () {
      this.limitCode = '';
      this.$emit('on-close');
    },
    onClickImg () {
      this.$emit('on-img-click');
    }
  }
};
</script>

<style lang="postcss" scoped>

.mask {
  z-index: 9999;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .6);
  .content {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 300px;
    padding: 0 20px;
    padding-bottom: 20px;
    margin: 0 auto;
    margin-left: -150px;
    background: #fff;
    transform: translateY(-50%);
  }
  .hd {
    font-size: 16px;
    height: 50px;
    line-height: 50px;
    color: #2B2D2E;
    text-align: center;
    img {
      position: absolute;
      right: 0;
      top: 0;
      width: 18px;
      height: 18px;
      padding: 5px;
      box-sizing: content-box;
      margin-top: 10px;
      margin-right: 12px;
      vertical-align: middle;
    }
  }
  .bd {
    overflow: hidden;
  }
  .input {
    float: left;
    width: 140px;
    height: 40px;
    padding: 3px 8px;
    border: 1PX solid #ddd;
    -webkit-appearance: none;
    border-radius: 2px;
    -webkit-user-select:auto;
    &:focus {
      border-color: #409eff;
    }
  }
  .code-img {
    float: right;
    width: 110px;
    height: 40px;
  }
  .button {
    margin-top: 20px;
    /deep/ .hsb-button-text {
      font-size: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/core/login/limitCodePopup.vue